import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { TileSet } from '../../tile-set-type-select/models/tile-set.model';
import * as AddDashBoardTileActions from './add-dashboard-tile.actions';

export const addDashboardTileFeatureKey = 'addDashboardTile';

export interface State {
   callState: CallState;
   tileSets: TileSet[] | null;
   searchText: string | null;
   lastAddedDashboardTileId: number | null;
}

export const initialState: State = {
   callState: LoadingState.Init,
   tileSets: null,
   searchText: null,
   lastAddedDashboardTileId: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddDashBoardTileActions.loadTileSets, (state) => {
      return { ...state, callState: LoadingState.Loading };
   }),
   on(AddDashBoardTileActions.loadTileSetsSuccess, (state, action) => {
      return { ...state, callState: LoadingState.Loaded, tileSets: action.tileSets };
   }),
   on(AddDashBoardTileActions.loadTileSetsFailure, (state, action) => {
      return { ...state, callState: { error: action.error } };
   }),
   on(AddDashBoardTileActions.searchTextChange, (state, action) => {
      return { ...state, searchText: action.searchText };
   }),
   on(AddDashBoardTileActions.addTile, (state, action) => {
      return { ...state, callState: LoadingState.Loading };
   }),
   on(AddDashBoardTileActions.addTileSuccess, (state, action) => {
      return { ...state, lastAddedDashboardTileId: action.dashboardTileId, callState: LoadingState.Loaded };
   }),
   on(AddDashBoardTileActions.addTileFailure, (state, action) => {
      return { ...state, callState: { error: action } };
   }),
   on(AddDashBoardTileActions.setLastAddedTileId, (state, action) => {
      return { ...state, lastAddedDashboardTileId: action.id };
   })
);
